module.exports = __webpack_public_path__ + "./img/VM-icon.svg";